import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'
import { LogOut } from 'lucide-react'
import Logo from '../../common/Logo'
import { authService } from '../../../services/authService'


const AuthHeader = ({ currentStep, totalSteps }) => {
    const navigate = useNavigate()

    const handleLogout = async () => {
        try {
            await authService.logout()
            navigate('/')
        } catch (error) {
            console.error('Logout error:', error)
        }
    }

    return (
        <header className="bg-white/80 dark:bg-black/20 backdrop-blur-xl border-b border-blue-200/50 dark:border-white/10">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between h-16">
                    {/* Logo */}
                    <Link to="/" className="flex items-center space-x-2">
                        <Logo />
                        <span className="text-2xl font-bold bg-gradient-to-r from-blue-900 to-cyan-800 dark:from-white dark:to-gray-300 bg-clip-text text-transparent">
                            AJA Bench
                        </span>
                    </Link>

                    {/* Progress Indicator */}


                    {/* Right side buttons */}
                    <div className="flex items-center space-x-3">
                        <motion.button
                            onClick={handleLogout}
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            className="flex items-center space-x-2 px-4 py-2 text-sm font-medium text-red-600 dark:text-red-400 hover:text-red-700 dark:hover:text-red-300 hover:bg-red-50 dark:hover:bg-red-900/30 rounded-lg transition-colors duration-200 border border-red-200 dark:border-red-800"
                        >
                            <LogOut className="w-4 h-4" />
                            <span className="hidden sm:inline">Logout</span>
                        </motion.button>
                    </div>
                </div>
            </div>
        </header>
    )
}
export default AuthHeader
